/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type FencedEnum = 1 | 2 | 3;

export const FencedEnum = {
    NUMBER_1: 1 as FencedEnum,
    NUMBER_2: 2 as FencedEnum,
    NUMBER_3: 3 as FencedEnum
};

